import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Background = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 300%;
    height: 100%;
    display: flex;
    z-index: -10;
    transition: all 1s cubic-bezier(0.99, 0.15, 0, 0.86);

    transform: ${({offset}) => `translateX(${offset.desktop})`};

    @media all and (max-width: 650px) {

      transform: ${({offset}) => `translateX(${offset.mobile})`};
      
    }
`

const BackA = styled.div`
  width: 50%;
  height: 100%;
  background-color: var(--main-color);
`

const BackB = styled.div`
  width: 50%;
  height: 100%;
  background-color: var(--secondary-color);
`

const DynamicBg = ({ location }) => {

  const [ offset, setOffset ] = useState({
    desktop: '50%',
    mobile: '50%'
  })

  useEffect(() => {
    location.pathname === '/' ? setOffset({mobile: '23%', desktop: '17%'}):
    location.pathname === '/tecnica' ? setOffset({mobile: '0%', desktop:'0%'}) :
    location.pathname === '/producto' ? setOffset({mobile: '-50%', desktop:'-50%'}) :
    location.pathname === '/caracteristicas' && setOffset({mobile: '32%', desktop:'-85%'})
  }, [location])

  return (
    <Background offset={offset}>
      <BackA />
      <BackB />
    </Background>
  )
}

export default DynamicBg